import * as React from 'react';
import {Helmet} from 'react-helmet';
import {observer, inject} from 'mobx-react';
import Card, {CardHeader, CardBody} from '../../components/Card';
import {FormComponentProps} from 'antd/lib/form/Form';
import {PromoteListingDetailModelType} from '../../models/PromoteListingDetailModel';
import ReactMapGL, {NavigationControl, Marker} from 'react-map-gl';
import {
  Form,
  Input,
  Switch,
  Button,
  message,
  Spin,
  Icon,
  Upload,
  Modal
} from 'antd';
import {RouteComponentProps} from 'react-router';
import {getAccessToken} from '../../services/tokenPersistence';

const {TextArea} = Input;
// tslint:disable

const MAPBOX_TOKEN =
  (window as any).MAPBOX_TOKEN || process.env.REACT_APP_MAPBOX_TOKEN;
const UPLOAD_ENDPOINT =
  (window as any).UPLOAD_ENDPOINT || process.env.REACT_APP_UPLOAD_ENDPOINT;

interface EditPromoteListingProps
  extends FormComponentProps,
    RouteComponentProps<{listingId: string; userId: string}> {
  promoteListingDetail: PromoteListingDetailModelType;
}

interface EditPromoteListingState {
  viewport: any;
  latitude: number;
  longitude: number;
  fileList: any;
  previewVisible: boolean;
  previewImage: string;
}

@inject('promoteListingDetail')
@observer
class EditPromoteListingForm extends React.Component<
  EditPromoteListingProps,
  EditPromoteListingState
> {
  constructor(props: EditPromoteListingProps) {
    super(props);
    this.state = {
      latitude: 37.776021,
      longitude: -122.4171949,
      viewport: {
        height: 400,
        width: 600,
        zoom: 12,
        latitude: 37.776021,
        longitude: -122.4171949
      },
      previewVisible: false,
      previewImage: '',
      fileList: []
    };
  }

  public updateViewport = (viewport: any) => {
    this.setState(prevState => ({
      viewport: {...prevState.viewport, ...viewport}
    }));
  };

  public resize = () => {
    this.setState(prevState => ({
      viewport: {
        ...prevState.viewport,
        height: 400,
        width: window.innerWidth - 300
      }
    }));
  };
  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  async componentDidMount() {
    await this._withInjectedProps.promoteListingDetail.getListing(
      this._listingId
    );
    const {listing} = this._withInjectedProps.promoteListingDetail;
    if (listing && listing.images) {
      const images = Array.from(listing.images.values());
      const fileList = images.reduce((results: any, image: any) => {
        const item = {
          uid: String(image.id),
          name: 'image.png',
          status: 'done',
          url: image.url
        };
        results.push(item);
        return results;
      }, []);
      this.setState({
        fileList: fileList,
        latitude: listing.latitude,
        longitude: listing.longitude,
        viewport: {
          ...this.state.viewport,
          latitude: listing.latitude,
          longitude: listing.longitude
        }
      });
    }
    window.addEventListener('resize', this.resize);
    this.resize();
  }

  handleCancel = () => this.setState({previewVisible: false});

  getBase64(file: any) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (reader.result) {
          resolve(reader.result);
        }
      };
      reader.onerror = error => reject(error);
    });
  }

  handlePreview = async (file: any) => {
    if (!file.url && !file.preview) {
      file.preview = await this.getBase64(file.originFileObj);
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true
    });
  };

  getUploadEndpoint() {
    return `${UPLOAD_ENDPOINT}/pictures/listing`;
  }

  handleChange = ({fileList}: any) => {
    this.setState({fileList});
  };

  renderUploadButton() {
    const {previewVisible, previewImage, fileList} = this.state;
    const token = getAccessToken();
    const uploadButton = (
      <Button>
        <Icon type="upload" /> Upload
      </Button>
    );
    return (
      <React.Fragment>
        <Upload
          action={this.getUploadEndpoint()}
          listType="picture-card"
          fileList={fileList}
          onPreview={this.handlePreview}
          onChange={this.handleChange}
          headers={{Authorization: `Bearer ${token}`}}
        >
          {uploadButton}
        </Upload>
        <Modal
          visible={previewVisible}
          footer={null}
          onCancel={this.handleCancel}
        >
          <img alt="example" style={{width: '100%'}} src={previewImage} />
        </Modal>
      </React.Fragment>
    );
  }

  private get _withInjectedProps() {
    return this.props as EditPromoteListingProps;
  }

  private get _listingId() {
    return Number(this._withInjectedProps.match.params.listingId);
  }
  private get _userId() {
    return Number(this._withInjectedProps.match.params.userId);
  }

  public render() {
    const {isLoading} = this._withInjectedProps.promoteListingDetail;
    return (
      <React.Fragment>
        <Helmet>
          <title>Edit Promote Listing</title>
        </Helmet>
        <Card>
          <CardHeader>Edit promote listing </CardHeader>
          <CardBody>
            {isLoading ? this._loading() : this._renderForm()}
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }
  private _loading() {
    return (
      <div>
        <Spin />
      </div>
    );
  }

  handleDragEndMarker = (event: any) => {
    const {setFieldsValue} = this.props.form;
    const lngLat = event.lngLat;
    setFieldsValue({
      latitude: lngLat[1],
      longitude: lngLat[0]
    });

    this.setState({
      latitude: lngLat[1],
      longitude: lngLat[0]
    });
  };

  private _renderForm() {
    const {getFieldDecorator} = this.props.form;
    const {listing} = this._withInjectedProps.promoteListingDetail;
    const {viewport} = this.state;
    if (!listing) {
      return null;
    }
    const formItemLayout = {
      labelCol: {
        xs: {span: 24},
        sm: {span: 4}
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 20}
      }
    };
    return (
      <Form layout="vertical" onSubmit={this._handleSubmit}>
        <Form.Item {...formItemLayout} label="Name">
          {getFieldDecorator('name', {
            initialValue: listing.name,
            rules: [
              {
                required: true,
                message: 'Name field is required.'
              }
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item {...formItemLayout} label="Internal Name">
          {getFieldDecorator('internalName', {
            initialValue: listing.internalName
          })(<Input />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label="Address">
          {getFieldDecorator('address', {
            initialValue: listing.address,
            rules: [
              {
                required: true,
                message: 'Address field is required'
              }
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item {...formItemLayout} label="Location">
          {getFieldDecorator('latitude', {
            initialValue: listing.latitude,
            rules: [
              {
                required: true,
                message: 'Latitude field is required'
              }
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item {...formItemLayout} label="Longitude">
          {getFieldDecorator('longitude', {
            initialValue: listing.longitude,
            rules: [
              {
                required: true,
                message: 'Longitude field is required'
              }
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item {...formItemLayout} label="Bedrooms">
          {getFieldDecorator('bedrooms', {
            initialValue: listing.bedrooms,
            rules: [
              {
                required: true,
                message: 'Bedrooms field is required'
              }
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item {...formItemLayout} label="Country Code">
          {getFieldDecorator('countryCode', {
            initialValue: listing.countryCode,
            rules: [
              {
                required: true,
                message: 'Country code field is required'
              }
            ]
          })(<Input />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label="Requirements">
          {getFieldDecorator('requirements', {
            initialValue: listing.requirements,
            rules: [
              {
                required: true,
                message: 'Requirements field is required'
              }
            ]
          })(<TextArea rows={8} />)}
        </Form.Item>
        <Form.Item {...formItemLayout} label="Commission">
          {getFieldDecorator('commission', {
            initialValue: listing.commission,
            rules: [
              {
                required: true,
                message: 'Commission field is required'
              }
            ]
          })(<TextArea rows={4} />)}
        </Form.Item>
        <Form.Item {...formItemLayout} label="Images">
          {getFieldDecorator('images', {
            initialValue: listing.images
          })(this.renderUploadButton())}
        </Form.Item>

        <Form.Item {...formItemLayout} label="Publish">
          {getFieldDecorator('state', {
            initialValue: listing.state === 'ACTIVATED',
            rules: [
              {
                required: true,
                message: 'Publish field is required'
              }
            ]
          })(<Switch defaultChecked={listing.state === 'ACTIVATED'} />)}
        </Form.Item>
        
        <ReactMapGL
          {...viewport}
          mapboxApiAccessToken={MAPBOX_TOKEN}
          onViewportChange={(v: any) => this.updateViewport(v)}
        >
          <div style={{position: 'absolute', right: 30, bottom: 30}}>
            <NavigationControl onViewportChange={this.updateViewport} />
          </div>
          <Marker
            draggable={true}
            latitude={this.state.latitude}
            longitude={this.state.longitude}
            onDragEnd={this.handleDragEndMarker}
          >
            <Icon
              type="environment"
              style={{color: 'red', fontSize: '30px'}}
            />
          </Marker>
        </ReactMapGL>

        <Form.Item {...formItemLayout}>
          <Button type="primary" htmlType="submit">
            Save change
          </Button>
        </Form.Item>
      </Form>
    );
  }

  private callback(err: boolean, msg: string) {
    if (err) {
      message.error(msg);
    } else {
      message.info(msg);
    }
  }

  private _getListingImages() {
    const {fileList} = this.state;
    if (!fileList) {
      return [];
    }

    return fileList.reduce((results: any, item: any) => {
      if (item.url) {
        results.push({
          url: item.url,
          id: Number(item.uid),
          caption: ''
        });
      } else if (item.response && item.response.url) {
        results.push({
          url: item.response.url,
          caption: ''
        });
      }
      return results;
    }, []);
  }
  private _handleSubmit = (e: any) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        return;
      }
      const data = values;
      data.userId = this._userId;
      data.state = data.state ? 'ACTIVATED' : 'DEACTIVATED';
      const images = this._getListingImages();
      data.images = images;
      this._withInjectedProps.promoteListingDetail.updateListing(
        this._listingId,
        data,
        this.callback
      );
    });
  };
}

const EditPromoteListing = Form.create()(EditPromoteListingForm);
export default EditPromoteListing;



// WEBPACK FOOTER //
// ./src/pages/EditPromoteListing/EditPromoteListing.tsx